(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["juveco-grid-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jgc-carousel')) {
    customElements.define(
      'jgc-carousel',
      class JgcCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.jgc__track');
          this.prev = this.querySelector('.jgc__arrow--prev');
          this.next = this.querySelector('.jgc__arrow--next');
          if (!this.track) return;

          this.prev && this.prev.addEventListener('click', () => this.page(-1));
          this.next && this.next.addEventListener('click', () => this.page(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => this.update());
            this.ro.observe(this.track);
          } else {
            window.addEventListener('resize', () => this.update());
          }
          this.update();
        }

        disconnectedCallback() {
          this.ro && this.ro.disconnect();
        }

        page(dir) {
          // advance exactly ONE item (item width + gap)
          const item = this.track.querySelector('.jgc__item');
          let step = this.track.clientWidth * 0.9;
          if (item) {
            const cs = getComputedStyle(this.track);
            const gap = parseFloat(cs.columnGap || cs.gap) || 0;
            step = item.getBoundingClientRect().width + gap;
          }
          this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
        }

        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          this.classList.toggle('jgc__carousel--no-scroll', max <= 2);
          if (this.prev) this.prev.disabled = t.scrollLeft <= 1;
          if (this.next) this.next.disabled = t.scrollLeft >= max - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-widget"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__waWidgetInit) return;
    window.__waWidgetInit = true;

    // Toggle open/close + analytics tracking via event delegation.
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-wa-toggle]');
      if (toggle) {
        var widget = toggle.closest('.wa-widget');
        if (widget) {
          var box = widget.querySelector('[data-wa-box]');
          if (box) box.hidden = !box.hidden;
        }
      }

      var track = e.target.closest('[data-wa-track]');
      if (track) {
        var label = track.getAttribute('data-wa-track');
        var host = track.closest('.wa-widget');

        // GTM
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'whatsapp_contact', wa_button_label: label });

        // GA4 (gtag) generate_lead — only if enabled on the section and gtag exists
        if (host && host.getAttribute('data-wa-ga4') === 'true' && typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', { method: 'whatsapp', wa_button_label: label });
        }
      }
    });

    // Show on scroll up / hide on scroll down (per widget opt-in).
    var lastScrollTop = 0;
    var delta = 5;

    function getScrollWidgets() {
      return document.querySelectorAll('.wa-widget[data-wa-behavior="scroll_up"]');
    }

    window.addEventListener('scroll', function () {
      var widgets = getScrollWidgets();
      if (!widgets.length) return;

      var st = window.scrollY || document.documentElement.scrollTop;
      if (Math.abs(lastScrollTop - st) <= delta) return;

      var goingDown = st > lastScrollTop && st > 100;
      var atBottom = st + window.innerHeight >= document.documentElement.scrollHeight;

      widgets.forEach(function (widget) {
        if (goingDown) {
          widget.classList.add('wa-hidden');
          var box = widget.querySelector('[data-wa-box]');
          if (box) box.hidden = true;
        } else if (!atBottom) {
          widget.classList.remove('wa-hidden');
        }
      });

      lastScrollTop = st <= 0 ? 0 : st;
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
